import { TableInsertModel, TableRowModel, TableUpdateModel } from '@examdojo/supabase';
import { CourseLevel } from '../model';

export type SyllabusUserSubscriptionHttpModel = Pick<
  TableRowModel<'syllabus_user_subscriptions', 'categories'>,
  'id' | 'user_id' | 'syllabus_id' | 'course_level' | 'exam_date_id' | 'created_at' | 'updated_at'
>;

export type SyllabusUserSubscriptionStoreModel = SyllabusUserSubscriptionHttpModel & {
  course_level: CourseLevel; // TODO: remove when phasing out CourseLevel
};

export type SyllabusUserSubscriptionUIModel = SyllabusUserSubscriptionStoreModel;

export const SYLLABUS_USER_SUBSCRIPTION_CREATE_ALLOWED_KEYS = [
  'user_id',
  'syllabus_id',
  'course_level',
  'exam_date_id',
] satisfies Array<keyof TableInsertModel<'syllabus_user_subscriptions', 'categories'>>;

export type SyllabusUserSubscriptionCreateModel = Pick<
  TableInsertModel<'syllabus_user_subscriptions', 'categories'>,
  (typeof SYLLABUS_USER_SUBSCRIPTION_CREATE_ALLOWED_KEYS)[number]
>;

export const SYLLABUS_USER_SUBSCRIPTION_UPDATE_ALLOWED_KEYS = [
  ...SYLLABUS_USER_SUBSCRIPTION_CREATE_ALLOWED_KEYS,
] satisfies Array<keyof TableUpdateModel<'syllabus_user_subscriptions', 'categories'>>;

export type SyllabusUserSubscriptionUpdateModel = Pick<
  TableUpdateModel<'syllabus_user_subscriptions', 'categories'>,
  (typeof SYLLABUS_USER_SUBSCRIPTION_UPDATE_ALLOWED_KEYS)[number]
>;
